(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('CommandManifest', CommandManifest);

    CommandManifest.$inject = ['$resource'];

    function CommandManifest($resource) {
        return $resource('api/command-manifest/:objectUniqueCode', {}, {
            'get': {
                method: 'GET',
                cache: false
            }

        });
    }
})();
